<template>
    <div>
        <b-card-header class="no-print">
            <!-- <h1>Följesedelsvisare</h1> -->
            <b-button variant="primary" @click="printNormal">
                                <i class="fa-solid fa-print"></i>
Skriv ut</b-button>
            &nbsp;
            <!-- <b-button variant="primary" @click="printPdf">
                <i class="fa-solid fa-file-pdf"></i>
                Ladda ned PDF</b-button> -->
            &nbsp;
            Antal: {{ bookings.length }}
        </b-card-header>
        <b-card-body>
            <div ref="pdfContent" id="pdf-content" class="pdf-content do-print">
                <div class="pdf-page-break" v-for="(b, i) in bookings" :key="i" >
                    <deliverynote :booking="b" ></deliverynote>
                    <div class="no-print text-center" style="background-color: gray; border-radius: 4px; border: 2px solid #ccc; padding: 10px; margin-top: 2px;">
                        <!-- <i>Ny sida</i> -->
                        
                    </div>
                </div>                
            </div>
        </b-card-body>
    </div>
</template>
<script>
import deliverynote from "./deliverynote.vue";

import { Api } from "../../lib/api";
const api = new Api();
import html2pdf from 'html2pdf.js';

export default {
    name: 'deliverynoteviewer',
    components: { deliverynote },
    data() {
        return {
            ids: [],
            bookings: [],
        };
    },
    mounted() {
        const hash = window.location.hash
        // hash = "#/deliverynoteviewer?ids=1904805,1904804"

        const queryString = hash.split('?')[1]
        const queryParams = new URLSearchParams(queryString)
        const idsstr = queryParams.get('ids') // "1904805,1904804"

        // const queryParams = new URLSearchParams(window.location.search);
        // const idsstr = queryParams.get('ids')
        if (idsstr.length > 0) {
            this.ids = idsstr.split(',');
            api.get('/api/sodexo/getbookings?ids=' + this.ids.join(',')).then((response) => {
                if (response.data && response.data.length > 0) {
                    this.bookings = response.data;

                    //Sort by SortOrder
                    this.bookings = this.bookings.sort((a, b) => a.SortOrder - b.SortOrder);

                } else {
                    this.bookings = [];
                }
            }).catch((error) => {
                console.error("Error fetching bookings:", error);
                this.bookings = [];
            });
        }

    },
    methods: {
        printNormal() {
            window.print();
        },
        printPdf() {
            const element = this.$refs.pdfContent;

      const options = {
        margin: [10, 10, 10, 10],
        filename:     'Sodexo Transplanet Följesedel.pdf',       
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },
        jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' },
         pagebreak: { mode: ['avoid-all', 'css', 'legacy']  }
      };

      html2pdf().set(options).from(element).save();
        }
    }

};

</script>
<style scoped>
.pdf-page-break {
  page-break-after: always;
}

 @media print {
      /* .do-print {
        display: block;
      } */

      .no-print {
        display: none;
      }

      .page-break {
        page-break-before: always;
      }

      @page {
        margin: 20mm;
      }
    }
</style>